import actions from './actions';

const {
  PERSON_ADD_BEGIN,
  PERSON_ADD_SUCCESS,
  PERSON_ADD_ERR,

  PERSON_READ_BEGIN,
  PERSON_READ_SUCCESS,
  PERSON_READ_ERR,

  PERSON_UPDATE_BEGIN,
  PERSON_UPDATE_SUCCESS,
  PERSON_UPDATE_ERR,

  SINGLE_PERSON_READ_BEGIN,
  SINGLE_PERSON_READ_SUCCESS,
  SINGLE_PERSON_READ_ERR,

  DAILY_WORK_ADD_BEGIN,
  DAILY_WORK_ADD_SUCCESS,
  DAILY_WORK_ADD_ERR,

  PERSON_WORK_READ_BEGIN,
  PERSON_WORK_READ_SUCCESS,
  PERSON_WORK_READ_ERR,

  EMPLOYEE_DATA_READ_BEGIN,
  EMPLOYEE_DATA_READ_SUCCESS,
  EMPLOYEE_DATA_READ_ERR,


  EMPLOYEE_READ_SUCCESS,
  EMPLOYEE_READ_ERR,
  EMPLOYEE_READ_BEGIN,



  HOLIDAYS_ADD_BEGIN,
  HOLIDAYS_ADD_SUCCESS,
  HOLIDAYS_ADD_ERR,


  HOLIDAY_UPDATE_BEGIN,
  HOLIDAY_UPDATE_SUCCESS,
  HOLIDAY_UPDATE_ERR,




  HOLIDAY_DELETE_BEGIN,
  HOLIDAY_DELETE_SUCCESS,
  HOLIDAY_DELETE_ERR,


} = actions;

const initialState = {
  data: [],
  url: null,
  fileLoading: false,
  loading: false,
  error: null,
};

const singlepersoninitialState = {
  data: [],
  url: null,
  fileLoading: false,
  loading: false,
  error: null,
};

const addinitialState = {
  data: [],
  url: null,
  fileLoading: false,
  loading: false,
  error: null,
};

const updateStateSingle = {
  data: null,
  loading: false,
  error: null,
};
const updateinitialState = {
  data: [],
  url: null,
  fileLoading: false,
  loading: false,
  error: null,
};

const deleteinitialState = {
  data: [],
  url: null,
  fileLoading: false,
  loading: false,
  error: null,
};




const HOLIDAYDeleteReducer = (state = deleteinitialState, action) => {
  const { type, data, err } = action;
  switch (type) {

    case HOLIDAY_DELETE_BEGIN:
      return {
        ...state,
        loading: true,
      };

    case HOLIDAY_DELETE_SUCCESS:
      return {
        ...state,
        data,
        error: false,
        loading: false,
      };

    case HOLIDAY_DELETE_ERR:
      return {
        ...state,
        error: err,
        loading: false,
      };

    default:
      return state;
  }
};



const holidayUpdateReducer = (state = updateinitialState, action) => {
  const { type, data, err } = action;
  switch (type) {
    case HOLIDAY_UPDATE_BEGIN:
      return {
        ...state,
        loading: true,
      };

    case HOLIDAY_UPDATE_SUCCESS:
      return {
        ...state,
        data,
        error: false,
        loading: false,
      };

    case HOLIDAY_UPDATE_ERR:
      return {
        ...state,
        error: err,
        loading: false,
      };

    default:
      return state;
  }
};




const HOLIDAYAddReducer = (state = addinitialState, action) => {
  const { type, data, err } = action;
  switch (type) {
    case HOLIDAYS_ADD_BEGIN:
      return {
        ...state,
        loading: true,
      };

    case HOLIDAYS_ADD_SUCCESS:
      return {
        ...state,
        data,
        error: false,
        loading: false,
      };

    case HOLIDAYS_ADD_ERR:
      return {
        ...state,
        error: err,
        loading: false,
      };


    default:
      return state;
  }
};

const PERSONReducer = (state = initialState, action) => {
  const { type, data, err } = action;
  switch (type) {
    case PERSON_READ_BEGIN:
      return {
        ...state,
        loading: true,
      };

    case PERSON_READ_SUCCESS:
      return {
        ...state,
        data,
        error: false,
        loading: false,
      };

    case PERSON_READ_ERR:
      return {
        ...state,
        error: err,
        loading: false,
      };

    default:
      return state;
  }
};

const SINGLEPERSONReducer = (state = singlepersoninitialState, action) => {
  const { type, data, err } = action;
  switch (type) {
    case SINGLE_PERSON_READ_BEGIN:
      return {
        ...state,
        loading: true,
      };

    case SINGLE_PERSON_READ_SUCCESS:
      return {
        ...state,
        data,
        error: false,
        loading: false,
      };

    case SINGLE_PERSON_READ_ERR:
      return {
        ...state,
        error: err,
        loading: false,
      };

    default:
      return state;
  }
};

const PERSONAddReducer = (state = addinitialState, action) => {
  const { type, data, err } = action;
  switch (type) {
    case PERSON_ADD_BEGIN:
      return {
        ...state,
        loading: true,
      };

    case PERSON_ADD_SUCCESS:
      return {
        ...state,
        data,
        error: false,
        loading: false,
      };

    case PERSON_ADD_ERR:
      return {
        ...state,
        error: err,
        loading: false,
      };


    default:
      return state;
  }
};

const PERSONUpdateReducer = (state = updateStateSingle, action) => {
  const { type, data, err } = action;
  switch (type) {

    case PERSON_UPDATE_BEGIN:
      return {
        ...state,
        loading: true,
      };

    case PERSON_UPDATE_SUCCESS:
      return {
        ...state,
        data,
        error: false,
        loading: false,
      };

    case PERSON_UPDATE_ERR:
      return {
        ...state,
        error: err,
        loading: false,
      };

    default:
      return state;
  }
};

const DAILY_WORKAddReducer = (state = addinitialState, action) => {
  const { type, data, err } = action;
  switch (type) {
    case DAILY_WORK_ADD_BEGIN:
      return {
        ...state,
        loading: true,
      };

    case DAILY_WORK_ADD_SUCCESS:
      return {
        ...state,
        data,
        error: false,
        loading: false,
      };

    case DAILY_WORK_ADD_ERR:
      return {
        ...state,
        error: err,
        loading: false,
      };


    default:
      return state;
  }
};

const PERSONWORKReducer = (state = initialState, action) => {
  const { type, data, err } = action;
  switch (type) {
    case PERSON_WORK_READ_BEGIN:
      return {
        ...state,
        loading: true,
      };

    case PERSON_WORK_READ_SUCCESS:
      return {
        ...state,
        data,
        error: false,
        loading: false,
      };

    case PERSON_WORK_READ_ERR:
      return {
        ...state,
        error: err,
        loading: false,
      };

    default:
      return state;
  }
};


const EMPLOYEE_DATAReducer = (state = singlepersoninitialState, action) => {
  const { type, data, err } = action;
  switch (type) {
    case EMPLOYEE_DATA_READ_BEGIN:
      return {
        ...state,
        loading: true,
      };

    case EMPLOYEE_DATA_READ_SUCCESS:
      return {
        ...state,
        data,
        error: false,
        loading: false,
      };

    case EMPLOYEE_DATA_READ_ERR:
      return {
        ...state,
        error: err,
        loading: false,
      };

    default:
      return state;
  }
};


const EMPLOYEEReducer = (state = singlepersoninitialState, action) => {
  const { type, data, err } = action;
  switch (type) {
    case EMPLOYEE_READ_BEGIN:
      return {
        ...state,
        loading: true,
      };

    case EMPLOYEE_READ_SUCCESS:
      return {
        ...state,
        data,
        error: false,
        loading: false,
      };

    case EMPLOYEE_READ_ERR:
      return {
        ...state,
        error: err,
        loading: false,
      };

    default:
      return state;
  }
};



export {
  SINGLEPERSONReducer, PERSONReducer, PERSONUpdateReducer,
  PERSONAddReducer, DAILY_WORKAddReducer, PERSONWORKReducer,
  EMPLOYEE_DATAReducer, EMPLOYEEReducer, HOLIDAYAddReducer, holidayUpdateReducer, HOLIDAYDeleteReducer

};
